// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ku-0";
export var fileCarousel = "_ku-2";
export var removeFileButton = "_ku-1";